import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMatchPreferencesQueryVariables = Types.Exact<{
    remoteWorkTypesInput: Types.TaxonomyConceptsInput;
}>;

export type GetMatchPreferencesQuery = {
    __typename?: 'Query';
    jobSeekerProfileStructuredData?:
        | {
              __typename?: 'JobSeekerProfileStructuredDataPayload';
              preferences: Array<{
                  __typename?: 'JobSeekerProfileStructuredDataPreference';
                  id?: string | null | undefined;
                  jobTitles: Array<{
                      __typename?: 'JobSeekerProfileStructuredDataJobTitle';
                      id?: string | null | undefined;
                      jobTitle?: string | null | undefined;
                  }>;
                  locations: Array<{
                      __typename?: 'JobSeekerProfileStructuredDataLocation';
                      id?: string | null | undefined;
                      formattedLocationShort?: string | null | undefined;
                  }>;
                  workAreas: Array<{
                      __typename?: 'JobSeekerProfileStructuredDataWorkArea';
                      id?: string | null | undefined;
                      sentiment: Types.JobSeekerProfileStructuredDataSentiment;
                      workAreaTaxonomyConcept?:
                          | {
                                __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept';
                                suid?: string | null | undefined;
                                label: string;
                            }
                          | null
                          | undefined;
                  }>;
                  jobTypes: Array<{
                      __typename?: 'JobSeekerProfileStructuredDataJobType';
                      id?: string | null | undefined;
                      jobType?: Types.JobSeekerProfileStructuredDataJobTypeEnum | null | undefined;
                      sentiment: Types.JobSeekerProfileStructuredDataSentiment;
                      jobTypeTaxonomyConcept?:
                          | {
                                __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept';
                                suid?: string | null | undefined;
                                label: string;
                            }
                          | null
                          | undefined;
                  }>;
                  shifts: Array<{
                      __typename?: 'JobSeekerProfileStructuredDataShift';
                      id?: string | null | undefined;
                      shift?: string | null | undefined;
                      sentiment: Types.JobSeekerProfileStructuredDataSentiment;
                      shiftTaxonomyConcept?:
                          | {
                                __typename?: 'JobSeekerProfileStructuredDataTaxonomyConcept';
                                suid?: string | null | undefined;
                                label: string;
                            }
                          | null
                          | undefined;
                  }>;
                  minimumPay?:
                      | {
                            __typename?: 'JobSeekerProfileStructuredDataSalary';
                            id?: string | null | undefined;
                            amount?: number | null | undefined;
                            currency?: string | null | undefined;
                            salaryType?:
                                | Types.JobSeekerProfileStructuredDataSalaryType
                                | null
                                | undefined;
                        }
                      | null
                      | undefined;
                  maximumCommute?:
                      | {
                            __typename?: 'JobSeekerProfileStructuredDataCommute';
                            timeMinutes?: number | null | undefined;
                        }
                      | null
                      | undefined;
                  relocation?:
                      | {
                            __typename?: 'JobSeekerProfileStructuredDataRelocation';
                            ableToRelocate?: boolean | null | undefined;
                        }
                      | null
                      | undefined;
                  attributes: Array<{
                      __typename?: 'JobSeekerProfileStructuredDataAttribute';
                      id: string;
                      suid: string;
                      label: string;
                      sentiment: Types.JobSeekerProfileStructuredDataSentiment;
                  }>;
              }>;
          }
        | null
        | undefined;
    remoteWorkTypes?:
        | {
              __typename?: 'TaxonomyConceptsPayload';
              taxonomyConcepts?:
                  | Array<{
                        __typename?: 'TaxonomyConcept';
                        uuid: string;
                        key: string;
                        label: string;
                    }>
                  | null
                  | undefined;
              responseStatus: {
                  __typename?: 'MdsResponseStatus';
                  errorMessage?: string | null | undefined;
                  responseCode: Types.MdsResponseCode;
              };
          }
        | null
        | undefined;
};

export const GetMatchPreferencesDocument = gql`
    query GetMatchPreferences($remoteWorkTypesInput: TaxonomyConceptsInput!) {
        jobSeekerProfileStructuredData(
            input: { queryFilter: { dataCategories: [CONFIRMED_BY_USER] } }
        ) {
            preferences {
                id
                jobTitles {
                    id
                    jobTitle
                }
                locations {
                    id
                    formattedLocationShort
                }
                workAreas {
                    id
                    workAreaTaxonomyConcept {
                        suid
                        label
                    }
                    sentiment
                }
                jobTypes {
                    id
                    jobType
                    jobTypeTaxonomyConcept {
                        suid
                        label
                    }
                    sentiment
                }
                shifts {
                    id
                    shift
                    shiftTaxonomyConcept {
                        suid
                        label
                    }
                    sentiment
                }
                minimumPay {
                    id
                    amount
                    currency
                    salaryType
                }
                maximumCommute {
                    timeMinutes
                }
                relocation {
                    ableToRelocate
                }
                attributes {
                    id
                    suid
                    label
                    sentiment
                }
            }
        }
        remoteWorkTypes: taxonomyConcepts(input: $remoteWorkTypesInput) {
            taxonomyConcepts {
                uuid
                key
                label
            }
            responseStatus {
                errorMessage
                responseCode
            }
        }
    }
`;

/**
 * __useGetMatchPreferencesQuery__
 *
 * To run a query within a React component, call `useGetMatchPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchPreferencesQuery({
 *   variables: {
 *      remoteWorkTypesInput: // value for 'remoteWorkTypesInput'
 *   },
 * });
 */
export function useGetMatchPreferencesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMatchPreferencesQuery,
        GetMatchPreferencesQueryVariables
    > &
        ({ variables: GetMatchPreferencesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetMatchPreferencesQuery, GetMatchPreferencesQueryVariables>(
        GetMatchPreferencesDocument,
        options,
    );
}
export function useGetMatchPreferencesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMatchPreferencesQuery,
        GetMatchPreferencesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetMatchPreferencesQuery, GetMatchPreferencesQueryVariables>(
        GetMatchPreferencesDocument,
        options,
    );
}
export function useGetMatchPreferencesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetMatchPreferencesQuery,
              GetMatchPreferencesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetMatchPreferencesQuery, GetMatchPreferencesQueryVariables>(
        GetMatchPreferencesDocument,
        options,
    );
}
export type GetMatchPreferencesQueryHookResult = ReturnType<typeof useGetMatchPreferencesQuery>;
export type GetMatchPreferencesLazyQueryHookResult = ReturnType<
    typeof useGetMatchPreferencesLazyQuery
>;
export type GetMatchPreferencesSuspenseQueryHookResult = ReturnType<
    typeof useGetMatchPreferencesSuspenseQuery
>;
export type GetMatchPreferencesQueryResult = Apollo.QueryResult<
    GetMatchPreferencesQuery,
    GetMatchPreferencesQueryVariables
>;
